import "./Header.css";
import "../index.css";
import logo from "../Assets/ritu broadband.png";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { LogIn } from "lucide-react";
import AuthModal from "./auth/AuthModal";

function Header() {
    const navigate = useNavigate();
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [role, setRole] = useState(null);
    const [showAuthModal, setShowAuthModal] = useState(false);

    useEffect(() => {
        setRole(sessionStorage.getItem("role"));
    }, [location]);

    const openLogin = () => {
        setMenuOpen(false);
        setShowAuthModal(true);
    };

    const handleLogout = () => {
        sessionStorage.removeItem("role");
        sessionStorage.removeItem("username");
        sessionStorage.removeItem("email");
        navigate("/");
    };

    return (
        <>
            <header>
                <div className="logo">
                    <a className="logo" href="/">
                        <img style={{ width: "172px" }} src={logo} alt="Ritu Broad Band" />
                    </a>
                </div>

                {/* Desktop Nav + Buttons */}
                <div className="header-buttons">
                    <nav className="header-nav">
                        <Link
                            to="/"
                            className={`header-nav-link${location.pathname === "/" ? " active" : ""}`}
                        >
                            Home
                        </Link>
                        <Link
                            to="/about"
                            className={`header-nav-link${location.pathname === "/about" ? " active" : ""}`}
                        >
                            About Us
                        </Link>
                        <Link
                            to="/plans"
                            className={`header-nav-link${location.pathname === "/plans" ? " active" : ""}`}
                        >
                            Plans
                        </Link>
                    </nav>

                    <div className="social-links">
                        <button
                            type="button"
                            onClick={openLogin}
                            className="header-btn-login"
                        >
                            <LogIn size={15} /> Login
                        </button>
                    </div>
                </div>

                {/* Hamburger (Mobile) */}
                <div className="hamburger" onClick={() => setMenuOpen(true)}>☰</div>
            </header>

            {/* Overlay for mobile menu */}
            {menuOpen && (
                <div className="overlay" onClick={() => setMenuOpen(false)} />
            )}

            {/* Mobile Side Menu */}
            <div className={`mobile-menu ${menuOpen ? "active" : ""}`}>
                <div className="close-btn" onClick={() => setMenuOpen(false)}>✖</div>
                <Link
                    to="/"
                    className={`mobile-nav-link${location.pathname === "/" ? " active" : ""}`}
                    onClick={() => setMenuOpen(false)}
                >
                    Home
                </Link>
                <Link
                    to="/about"
                    className={`mobile-nav-link${location.pathname === "/about" ? " active" : ""}`}
                    onClick={() => setMenuOpen(false)}
                >
                    About Us
                </Link>
                <Link
                    to="/plans"
                    className={`mobile-nav-link${location.pathname === "/plans" ? " active" : ""}`}
                    onClick={() => setMenuOpen(false)}
                >
                    Plans
                </Link>
                <button onClick={openLogin} className="mobile-btn">Login</button>
            </div>

            {/* Auth Modal Popup */}
            {showAuthModal && (
                <AuthModal onClose={() => setShowAuthModal(false)} />
            )}
        </>
    );
}

export default Header;
